import {
  loginUser,
  updateFirstLoginPassword,
} from "../../../Redux/Auth/AuthActions";
import ForgotPassword from "../../../Components/User/ForgotPassword/ForgotPassword";
import PasswordModal from "../../../Components/User/PasswordModal/PasswordModal";
import Agreement from "../../../Components/User/Bookings/Agreement/Agreement";
import OtpModal from "../../../Components/User/OtpModal/OtpModal";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import { Link, useLocation, useNavigate } from "react-router";
import Modal from "../../../Components/Common/Modal/Modal";
import LoginImage from "../../../Assets/LoginImage.png";
import { useDispatch, useSelector } from "react-redux";
import SignatureCanvas from "react-signature-canvas";
import toastHelper from "../../../Util/toastHelper";
import validator from "../../../Util/validator";
import { FaRegEyeSlash } from "react-icons/fa6";
import React, { useRef, useState } from "react";
import Logo from "../../../Assets/Logo.png";
import { FaRegEye } from "react-icons/fa6";
import styles from "./Login.module.scss";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const { loading, submitOtpData, updateFirstLoginPasswordLoading } =
    useSelector((state: RootState) => state.auth);
  const location = useLocation();
  const signRef = useRef<SignatureCanvas | null>(null);
  const signupSuccess = location.state?.signup_success;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [forgotPasswordModal, setForgotPasswordModal] = useState(false);
  const [otpModalOpen, setOtpModalOpen] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [agreementModalOpen, setAgreementModalOpen] = useState(false);
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [errors, setErrors] = useState<{
    email: string;
    password: string;
  }>({
    email: "",
    password: "",
  });

  const openOtpModalHandler = () => {
    setOtpModalOpen(true);
  };

  const loginHandler = (e: React.FormEvent) => {
    e.preventDefault();
    const { errors: fieldErrors, isValid } = validator([
      {
        key: "email",
        type: "email",
        value: email,
      },
      {
        key: "password",
        type: "password",
        value: password,
      },
    ]);
    setErrors({ ...errors, ...fieldErrors });

    if (isValid) {
      if (!loading) {
        dispatch(loginUser({ email, password }, openOtpModalHandler));
      }
    }
  };

  const openPasswordModalHandler = () => {
    setPasswordModalOpen(true);
  };

  const passwordProcessHandler = (password: string) => {
    setNewPassword(password);
    setPasswordModalOpen(false);
    setOtpModalOpen(false);
    setAgreementModalOpen(true);
  };

  const agreementHandler = () => {
    if (signRef?.current) {
      if (signRef.current.isEmpty()) {
        toastHelper.error("Please sign the agreement");
      } else {
        if (!updateFirstLoginPasswordLoading) {
          const successHandler = () => {
            setPassword("");
            setNewPassword("");
            setPassword("");
            setAgreementModalOpen(false);
            navigate("/");
          };
          dispatch(
            updateFirstLoginPassword(
              {
                email,
                password: newPassword,
                signature: signRef.current.toDataURL(),
              },
              successHandler,
              navigate,
            ),
          );
        }
      }
    }
  };

  return (
    <React.Fragment>
      {updateFirstLoginPasswordLoading && <Loading />}
      <Modal
        isOpen={agreementModalOpen}
        setIsOpen={setAgreementModalOpen}
        showCloseIcon={false}
      >
        <Agreement
          signRef={signRef}
          termsAndConditions={submitOtpData?.terms?.content}
        />

        <div className={styles.proceedButtonContainer}>
          <button onClick={agreementHandler} className={styles.button}>
            Proceed
          </button>
          <button
            onClick={() => setAgreementModalOpen(false)}
            className={styles.cancelButton}
          >
            Cancel
          </button>
        </div>
      </Modal>
      <Modal isOpen={forgotPasswordModal} setIsOpen={setForgotPasswordModal}>
        <ForgotPassword
          isOpen={forgotPasswordModal}
          setIsOpen={setForgotPasswordModal}
        />
      </Modal>
      <OtpModal
        isOpen={otpModalOpen}
        setIsOpen={setOtpModalOpen}
        email={email}
        password={password}
        openPasswordModalHandler={openPasswordModalHandler}
      />
      <PasswordModal
        isOpen={passwordModalOpen}
        setIsOpen={setPasswordModalOpen}
        passwordProcessHandler={passwordProcessHandler}
      />
      <div className={styles.mainContainer}>
        {/* Left Container - Image */}
        <div className={styles.leftContainer}>
          <div className={styles.imageContainer}>
            <img src={LoginImage} alt="Login" className={styles.image} />
          </div>
        </div>

        {/* Right Container - Login form */}
        <div className={styles.rightContainer}>
          <div className={styles.loginFormContainer}>
            {/* Logo */}
            <div className={styles.logoContainer}>
              <img src={Logo} alt="Logo" className={styles.logo} />
            </div>
            {signupSuccess && (
              <div className={styles.informationContainer}>
                <p className={styles.information}>
                  Registration successful, Please login
                </p>
              </div>
            )}
            {/* Login Form */}
            <form
              className={`${styles.loginForm} ${loading ? styles.submitting : ""}`}
              onSubmit={loginHandler}
            >
              {/* Email Input */}
              <div className={styles.inputContainer}>
                <p className={styles.label}>Email</p>
                <input
                  type="text"
                  className={styles.input}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  autoComplete="on"
                />
                <p className={styles.error}>{errors.email}</p>
              </div>

              {/* Password Input */}
              <div className={styles.inputContainer}>
                <p className={styles.label}>Password</p>
                <div className={styles.passwordInputContainer}>
                  <input
                    type={showPassword ? "text" : "password"}
                    className={styles.input}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    autoComplete="current-password"
                  />
                  <button
                    type="button"
                    className={styles.showPasswordButton}
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? (
                      <FaRegEyeSlash className={styles.icon} />
                    ) : (
                      <FaRegEye className={styles.icon} />
                    )}
                  </button>
                </div>
                <p className={styles.error}>{errors.password}</p>
              </div>

              {/* Login Button */}

              {loading && <Loading />}

              {/* Login Button */}
              <div className={styles.loginButtonContainer}>
                <button type="submit" className={styles.loginBtn}>
                  Login
                </button>
              </div>

              {/* Forgot Password Button */}
              <div className={styles.forgotPasswordContainer}>
                <button
                  type="button"
                  className={styles.forgotPasswordBtn}
                  onClick={() => setForgotPasswordModal(true)}
                >
                  Forgot Password
                </button>
              </div>

              {/* Signup Button */}
              <Link
                to="/signup"
                replace
                className={styles.signupButtonContainer}
              >
                <button type="button" className={styles.signupBtn}>
                  Sign Up
                </button>
              </Link>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Login;
